const STORAGE_KEY = "ist_clock_format";
export const CLOCK_FORMAT_12H = "12h";
export const CLOCK_FORMAT_24H = "24h";
export const CLOCK_FORMAT_CHANGED = "ist-clock-format-changed";

export function getClockFormat() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === CLOCK_FORMAT_24H) return CLOCK_FORMAT_24H;
  } catch {
    /* ignore */
  }
  return CLOCK_FORMAT_12H;
}

export function setClockFormat(format) {
  const next = format === CLOCK_FORMAT_24H ? CLOCK_FORMAT_24H : CLOCK_FORMAT_12H;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent(CLOCK_FORMAT_CHANGED, { detail: { format: next } })
  );
  return next;
}

export function is12HourClockFormat(format = getClockFormat()) {
  return format !== CLOCK_FORMAT_24H;
}
